(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["twc-account-sidebar"] && !Shopify.designMode) return;
  try {
    
  // <twc-profile-panel>: the CORRECTION layer over the facts Liquid already
  // painted from the member's `twc` customer metafields.
  //
  // Two rules, and they are the whole design:
  //   1. A value the engine knows OVERWRITES what Liquid rendered. The
  //      metafield projection is queued, so the metafield can be seconds (or a
  //      failed drain) behind the truth; the proxy payload is the truth.
  //   2. A fact Liquid rendered is NEVER hidden. The engine payload not
  //      carrying a field means "nothing to correct with", not "not true" —
  //      only a fact Liquid left blank may be hidden again.
  // Facts Liquid has no metafield for (referredBy, creditBalance, and the
  // payload-only favouriteWhisky source) keep the fill-and-unhide behaviour.
  // The metafield-backed favourite_whisky source obeys the two rules above.
  //
  // The avatar <img> is owned by <twc-avatar-upload> (CDN transform, silhouette
  // fallback, optimistic preview all live there), so this panel never touches
  // it — Liquid seeds its src, that island corrects it from the same payload.
  (function () {
    if (customElements.get('twc-profile-panel')) return;

    var Panel = function () {
      return Reflect.construct(HTMLElement, [], Panel);
    };
    Panel.prototype = Object.create(HTMLElement.prototype);
    Panel.prototype.constructor = Panel;

    Panel.prototype.connectedCallback = function () {
      var self = this;
      // Tier labels are member-facing copy, so they live in the locale file and
      // ride in through the JSON script tag: this block is compiled into the
      // theme's JS bundle and never sees Liquid, so it cannot call `t` itself.
      this.tiers = {};
      var i18n = this.querySelector('script[data-twc-profile-i18n]');
      if (i18n) {
        try {
          var raw = JSON.parse(i18n.textContent) || {};
          this.tiers = window.TwcAccountApi ? window.TwcAccountApi.decodeDeep(raw) : raw;
        } catch (e) { /* no labels: the Liquid-rendered tier stands uncorrected */ }
      }
      var tries = 0;
      var timer = setInterval(function () {
        if (window.TwcMemberData) {
          clearInterval(timer);
          self._unsub = window.TwcMemberData.subscribe(function (s) { self.sync(s); });
        } else if (++tries > 200) {
          clearInterval(timer);
        }
      }, 25);
      this._timer = timer;
    };

    Panel.prototype.disconnectedCallback = function () {
      if (this._timer) clearInterval(this._timer);
      if (this._unsub) { this._unsub(); this._unsub = null; }
    };

    // Local calendar day as YYYY-MM-DD — ISO date strings compare correctly as
    // plain strings, and no Date parse of a date-only value is involved (that
    // would read as UTC midnight and lose a day west of UTC).
    function todayKey() {
      var d = new Date();
      var m = d.getMonth() + 1;
      var day = d.getDate();
      return d.getFullYear() + '-' + (m < 10 ? '0' + m : m) + '-' + (day < 10 ? '0' + day : day);
    }

    // '' means "the engine has nothing for this fact".
    Panel.prototype.valueFor = function (key, s) {
      var me = (s && s.me) || null;
      var profile = (me && me.profile) || null;
      if (key === 'tier') {
        return me && me.tier && this.tiers[me.tier] ? this.tiers[me.tier] : '';
      }
      if (key === 'pausedUntil') {
        // STATUS decides, not the date: a member who came back is not paused,
        // whatever a stale pausedUntil column or metafield still says.
        if (me && me.status !== 'paused') return '';
        // Unpausing DELETES the metafield, but that write is queued: /me is what
        // clears a stale chip. An elapsed pause is not a pause either.
        // me.pausedUntilDate is the STORE-LOCAL calendar date (engine-derived);
        // the raw instant's UTC date part can read a day early. The raw
        // instant is the fallback when the payload carries no pausedUntilDate.
        var until = me ? (me.pausedUntilDate || me.pausedUntil) : null;
        if (!until) return '';
        if (String(until).slice(0, 10) < todayKey()) return '';
        return window.TwcAccountApi ? window.TwcAccountApi.calendarDate(until) : String(until);
      }
      if (key === 'referralCode') {
        if (s && s.referrals && s.referrals.referralCode) return String(s.referrals.referralCode);
        return profile && profile.referralCode ? String(profile.referralCode) : '';
      }
      if (key === 'creditBalance') {
        // Engine credit-ledger balance rides `me` directly, not me.profile.
        // Island-only fact (no metafield, Liquid renders nothing): '' keeps
        // the row hidden — including at exactly 0, M2 parity. No raw-cents
        // fallback: without the money formatter the row stays hidden rather
        // than showing "1500".
        var cents = me ? me.creditBalanceCents : null;
        if (typeof cents !== 'number' || !(cents > 0)) return '';
        return window.TwcAccountApi ? window.TwcAccountApi.money(cents, me.currency) : '';
      }
      // The metafield-backed favourite whisky. Liquid paints it from
      // customer.metafields.twc.favourite_whisky; the payload carries the same
      // fact under its camelCase name, thus the correction rules apply to it
      // like every other projected fact.
      if (key === 'favourite_whisky') {
        var fav = profile ? profile.favouriteWhisky : null;
        // A read-only member preview reads it from GET /profile instead.
        if ((fav == null || fav === '') && window.TwcPreview && window.TwcPreview.active()) {
          fav = window.TwcPreview.extra('favouriteWhisky');
        }
        return fav == null || fav === '' ? '' : String(fav);
      }
      var val = profile ? profile[key] : null;
      if (val == null || val === '') return '';
      var text = String(val);
      if (key === 'memberSince') {
        // engine sends an ISO timestamp; the board shows "January 2020". The
        // Liquid paint is the store's calendar month (a store-local date
        // metafield), so the instant is read in the store's own time zone,
        // daylight saving included: Sydney for AU, Auckland for NZ.
        var d = new Date(text);
        if (!isNaN(d)) {
          var zone = me && me.storeCode === 'nz' ? 'Pacific/Auckland' : 'Australia/Sydney';
          try {
            text = new Intl.DateTimeFormat('en-AU', { month: 'long', year: 'numeric', timeZone: zone }).format(d);
          } catch (e) {
            text = d.toLocaleDateString('en-AU', { month: 'long', year: 'numeric' });
          }
        }
      }
      return text;
    };

    Panel.prototype.sync = function (s) {
      var profile = (s.me && s.me.profile) || null;
      var facts = this.querySelector('[data-twc-facts]');
      if (!facts) return;
      if (profile && profile.name) {
        var nameEl = this.querySelector('[data-twc-name]');
        if (nameEl) nameEl.textContent = profile.name;
      }
      // Paused swap: while /me reports a live pause the tier row hides and the
      // pausedUntil row shows, whatever Liquid painted. A member who pauses
      // on this page therefore loses the tier row at once, and one who
      // resumes gets it back.
      var paused = !!this.valueFor('pausedUntil', s);
      // A read-only member preview tab: Liquid painted whoever is signed in
      // (or nobody), so rule 2 does not hold there — the engine payload is
      // the only source and an empty value hides the row.
      var preview = !!(window.TwcPreview && window.TwcPreview.active());
      var any = false;
      var els = this.querySelectorAll('[data-twc-fact]');
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        var key = el.getAttribute('data-twc-fact');
        var swappedOut = key === 'tier' && paused;
        var text = swappedOut ? '' : this.valueFor(key, s);
        if (text) {
          var suffix = el.getAttribute('data-twc-suffix');
          if (suffix && /^\d+$/.test(text)) text += ' ' + suffix;
          el.querySelector('[data-twc-value]').textContent = text;
          el.hidden = false;
          any = true;
        } else if (el.hasAttribute('data-twc-liquid') && !preview && !(s.me && key === 'pausedUntil') && !swappedOut) {
          // rule 2: Liquid rendered it, so it stays — EXCEPT pausedUntil once
          // /me has loaded: an empty value there is the authoritative "not
          // paused" (unpausing deletes the metafield and /me is what clears
          // the stale chip — see valueFor), and EXCEPT the tier row while
          // paused (the swap above). For every other fact '' can mean
          // projection lag (memberSince) or a missing i18n label over a real
          // value (tier), where blanking the SSR'd row would be wrong.
          any = true;
        } else {
          el.hidden = true;
        }
      }
      facts.hidden = !any;
    };

    customElements.define('twc-profile-panel', Panel);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["twc-distillery-post"] && !Shopify.designMode) return;
  try {
    
  // <twc-distillery-video>: click-to-swap video embed. Liquid resolves the
  // provider embed URL at render time and prints it on the element; the first
  // click on the play control replaces the poster stage with the iframe, and
  // the element does nothing else. The AbortController releases the listener
  // when the element leaves the DOM.
  (function () {
    if (customElements.get('twc-distillery-video')) return;

    var Video = function () {
      return Reflect.construct(HTMLElement, [], Video);
    };
    Video.prototype = Object.create(HTMLElement.prototype);
    Video.prototype.constructor = Video;

    Video.prototype.connectedCallback = function () {
      var self = this;
      this._abort = new AbortController();
      var play = this.querySelector('[data-twc-video-play]');
      if (!play) return;
      play.addEventListener(
        'click',
        function () {
          self.swap();
        },
        { signal: this._abort.signal }
      );
    };

    Video.prototype.disconnectedCallback = function () {
      if (this._abort) {
        this._abort.abort();
        this._abort = null;
      }
    };

    Video.prototype.swap = function () {
      var src = this.getAttribute('data-embed-src');
      var stage = this.querySelector('[data-twc-video-stage]');
      if (!src || !stage) return;
      var frame = document.createElement('iframe');
      frame.src = src;
      frame.title = this.getAttribute('data-embed-title') || '';
      frame.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture; encrypted-media');
      frame.setAttribute('allowfullscreen', '');
      frame.className = 'twc-distillery-post__video-frame';
      stage.replaceChildren(frame);
    };

    customElements.define('twc-distillery-video', Video);
  })();

  } catch(e) { console.error(e); }
})();
})();
